import React from 'react';
import { Row, Col } from 'reactstrap';
import { BadgePercent, Package, FileText, Building2 } from 'lucide-react';

const stats = (business) => [
	{
		label: 'Group Deals',
		value: business?.groupDeals?.length || 0,
		icon: BadgePercent,
	},
	{
		label: 'Products',
		value: business?.products?.length || 0,
		icon: Package,
	},
	{
		label: 'Posts',
		value: business?.newsFeeds?.length || 0,
		icon: FileText,
	},
	{
		label: 'Buildings',
		value: business?.buildings?.length || 0,
		icon: Building2,
	},
];

const StatsCards = ({ business }) => {
	return (
		<Row className='dashboard-stats-row'>
			{stats(business).map((item) => {
				const Icon = item.icon;

				return (
					<Col xl='3' md='6' sm='6' xs='12' key={item.label}>
						<div className='dashboard-stat-card'>
							<div className='dashboard-stat-card__top'>
								<div className='dashboard-stat-card__icon'>
									<Icon size={20} />
								</div>
							</div>

							<div className='dashboard-stat-card__value'>{item.value}</div>
							<div className='dashboard-stat-card__label'>{item.label}</div>
						</div>
					</Col>
				);
			})}
		</Row>
	);
};

export default StatsCards;
